module.exports = __webpack_public_path__ + "img/mini-logo.00abe306.png";